var $$ = $$ || {};

$$.ContactsMap = class GoogleMap {
	constructor (root = $, options = {}) {
		var defaultOptions = {
			mapOptions: {
				zoom: 14,
				styles: [{
					"featureType": "administrative",
					"elementType": "labels.text.fill",
					"stylers": [{"color": "#444444"}]
				}, {
					"featureType": "landscape",
					"elementType": "all",
					"stylers": [{"color": "#f2f2f2"}]
				}, {
					"featureType": "poi",
					"elementType": "all",
					"stylers": [{"visibility": "off"}]
				}, {
					"featureType": "road",
					"elementType": "all",
					"stylers": [{"saturation": -100}, {"lightness": 45}]
				}, {
					"featureType": "road.highway",
					"elementType": "all",
					"stylers": [{"visibility": "simplified"}]
				}, {
					"featureType": "road.arterial",
					"elementType": "labels.icon",
					"stylers": [{"visibility": "off"}]
				}, {
					"featureType": "transit",
					"elementType": "all",
					"stylers": [{"visibility": "off"}]
				}, {
					"featureType": "water",
					"elementType": "all",
					"stylers": [{"color": "#0088f6"}, {"visibility": "on"}]
				}],
				disableDefaultUI: true
			},
			rootDefaultHeight: 300,
			rootExpandHeight: 600,
			mapDefaultTop: -150,
			mapExpandTop: 0
		};

		this.map;
		this.centerMap;

		this.root = root;
		this.options = _.merge(options || {}, defaultOptions, _.defaults);
		this.initialize();

		this._cacheNodes();
		this._bindEvents();
	}

	initialize () {
		setTimeout(() => {
			this._createMap();
		}, 0);

	}

	_cacheNodes () {
		this.nodes = {
			map: this.root.find('.js-map'),
			expandMap: this.root.find('.js-expand-map'),
			expandMapText: this.root.find('.js-expand-map-text'),
			reduceMapText: this.root.find('.js-reduce-map-text')
		};
	}

	_bindEvents () {
		setTimeout(() => {
			$$.window.on('resize', () => {
				this.map.setCenter(this.centerMap);
			});

			this.nodes.expandMap.on('click', (event) => {
				if (!$(event.currentTarget).data('expand')) {
					$(event.currentTarget).data('expand', true);
					this.root.height(this.options.rootExpandHeight);
					this.nodes.map.css({top: this.options.mapExpandTop});
					this.nodes.expandMapText.hide();
					this.nodes.reduceMapText.show();
				} else {
					$(event.currentTarget).data('expand', false);
					this.root.height(this.options.rootDefaultHeight);
					this.nodes.map.css({top: this.options.mapDefaultTop});
					this.nodes.expandMapText.show();
					this.nodes.reduceMapText.hide();
				}

				return false;
			});
		}, 0);
	}

	_createMap () {
		var coordinates = this.nodes.map.data('coordinates');

		this.centerMap = new google.maps.LatLng(coordinates[0], coordinates[1]);
		this.map = new google.maps.Map(this.nodes.map.get(0), this.options.mapOptions);
		this.map.setCenter(this.centerMap);

		google.maps.event.addListenerOnce(this.map, 'idle', () => {
			this.updatedMapCenter = this._calculateCenter();
			this._addMarker();
			this.map.setCenter(this.updatedMapCenter);
		});
	}

	_calculateCenter () {
		var projection = this.map.getProjection();
		var wc = projection.fromLatLngToPoint(this.centerMap);
		var sw = new google.maps.Point(wc.x, wc.y);

		return projection.fromPointToLatLng(sw);
	}

	_addMarker () {
		new google.maps.Marker({
			position: this.centerMap,
			map: this.map,
			//animation: google.maps.Animation.DROP,
			icon: '/site/assets/images/point.png'
		});
	}
};
